/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {confirmTriggeredAction} from '../api'

export const useMutationConfirmTriggeredAction = createReactQueryMutationHook('confirmTriggeredAction', confirmTriggeredAction)
